<template>
  <v-main id="MainTable" style="max-width: unset" class="pa-0 ma-0">
    <!-- Modal deletar -->
    <v-dialog v-model="deleteDialog" max-width="420px">
      <DeleteModal
        title="Deletar"
        textMessage="Tem certeza que excluir este cupom de desconto?"
        cancelBtn="Cancelar"
        okbtn="Deletar"
        textObservation=""
        icone="mdi-trash-can-outline"
        @close="(deleteDialog = false), updateTable()"
        @action="(deleteDialog = false), remove()"
        @closeNoLoading="closeNoLoading"
        :key="dialogKey"
      />
    </v-dialog>

    <!-- Dialog DETAILS  -->
    <v-dialog
      transition="dialog-bottom-transition"
      v-model="detailsDialog"
      max-width="1200"
    >
      <DetailsCoupon
        title="Detalhes"
        :coupon="this.currentCoupon"
        @action="detailsDialog = false"
        @close="detailsDialog = false"
        @closeNoLoading="closeNoLoading"
        :key="dialogKey"
      />
    </v-dialog>

    <!-- Exportar Excel -->
    <v-dialog
      transition="dialog-bottom-transition"
      v-model="excelDialog"
      max-width="500px"
    >
      <ExcelModal
        title="Exportar Cuppons"
        textMessage="Deseja exportar os cupons para excel ?"
        cancelBtn="Cancelar"
        okbtn="Sim, exportar"
        icone="mdi-arrow-up-circle"
        textObservation=""
        @close="excelDialog = false"
        @generate="(excelDialog = false), generateExcel()"
        @closeNoLoading="closeNoLoading"
        :key="dialogKey"
      />
    </v-dialog>

    <v-dialog v-model="confirmActionDialog" max-width="450">
      <ConfirmModal
          v-if="action"
          title=""
          textMessage=""
          :textObservation1="`Deseja realmente ${actions.find((x) => x.value === action).label} selecionados?`"
          textObservation2=""
          cancelBtn="Cancelar"
          okbtn="Sim"
          textObservation=""
          @close="(confirmActionDialog = false)"
          @action="performAction()"
      />
    </v-dialog>

    <v-dialog v-model="addDialog" max-width="600px">
      <v-card class="card pa-6 mx-auto" elevation="2">
        <p class="type-coupon-title">{{ addTitle }}</p>
        <p class="type-coupon-description">
          {{ addMessage }}
        </p>
        <v-row
          class="px-2"
          cols="12"
          md="12"
          sm="12"
          style="padding-left: 10px; margin-top: -20px"
        >
          <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
            <v-btn
              class="ghost-buttons-outlined-black"
              elevation="0"
              width="100%"
              @click="addDialog = false"
            >
              Cancelar
            </v-btn>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
            <v-btn
              class="sixth-button"
              elevation="0"
              width="100%"
              @click="goToRoute(`add-coupons?type=${type}`)"
            >
              Incluir</v-btn
            >
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>

    <HeaderProduct
      title="Produtos | Incluir Cupom de desconto"
      text="Inclua novos cupons e gerencie os cupons de desconto existentes"
      @voltar="$router.push('/products')"
      :haveBack="true"
    />

    <v-container style="max-width: unset" class="pa-4">
      <v-tabs
        class="px-0"
        background-color="#ECEEF1"
        grow
        height="55"
        hide-slider
      >
        <v-tab
          active-class="active-tab"
          class="tab"
          id="tab0"
          style="font-weight: bold !important"
          href="#mobile-tabs-5-0"
          @click="activeTab = 0"
        >
          <span style="font-weight: bold">Cadastrar Cupom</span>
        </v-tab>

        <v-tab
          active-class="active-tab"
          class="tab"
          id="tab1"
          href="#mobile-tabs-5-1"
          @click="activeTab = 1"
        >
          <span style="font-weight: bold">Cupons ativos</span>
        </v-tab>

        <v-tab
          active-class="active-tab"
          class="tab"
          id="tab2"
          href="#mobile-tabs-5-2"
          @click="activeTab = 2"
        >
          <span style="font-weight: bold">Gestão de cupons</span>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="activeTab">
        <v-tab-item :value="0">
          <v-card class="ma-0 pa-4 py-4">
            <v-row>
              <v-col cols="12" md="12" sm="12">
                <span class="texto-p pa-5">
                  Selecione para qual objetivo será utilizado o cupom.
                </span>
              </v-col>
              <v-col class="pa-7" cols="12" md="6" sm="12">
                <div class="title-g">Cadastrar novo cupom</div>
                <span class="texto-p"
                  >Selecione o tipo de cupom que você quer cadastrar</span
                >
              </v-col>
              <v-col
                class="d-flex"
                style="justify-content: space-around"
                cols="12"
                md="6"
                sm="12"
              >
                <v-card
                  @click="
                    (type = 1),
                      (addTitle = 'Incluir cupom de desconto'),
                      (addMessage =
                        'Tem certeza que deseja incluir o cupom de desconto para todos os usuários?'),
                      (addDialog = true)
                  "
                  class="card-cupon pa-2 ma-2 py-7"
                >
                  <div>
                    <v-icon class="icon" style="font-size: xxx-large">
                      mdi-cart-outline
                    </v-icon>
                    <div>Toda a loja</div>
                  </div>
                </v-card>
                <v-card
                  @click="
                    (type = 3),
                      (addTitle =
                        'Incluir cupom de desconto a categoria específica'),
                      (addMessage =
                        'Tem certeza que deseja incluir o cupom de desconto para a categoria específica?'),
                      (addDialog = true)
                  "
                  class="card-cupon pa-2 ma-2 py-7"
                >
                  <div>
                    <v-icon class="icon" style="font-size: xxx-large">
                      mdi-palette-swatch
                    </v-icon>
                    <div>Categoria</div>
                  </div>
                </v-card>
                <v-card
                  @click="
                    (type = 4),
                      (addTitle =
                        'Incluir cupom de desconto a sub-categoria específica'),
                      (addMessage =
                        'Tem certeza que deseja incluir o cupom de desconto para sub-categoria específica?'),
                      (addDialog = true)
                  "
                  class="card-cupon pa-2 ma-2 py-7"
                >
                  <div>
                    <v-icon class="icon" style="font-size: xxx-large">
                      mdi-palette-swatch-outline
                    </v-icon>
                    <div>Sub-categoria</div>
                  </div>
                </v-card>
                <v-card
                  @click="
                    (type = 5),
                      (addTitle =
                        'Incluir cupom de desconto a produto específico'),
                      (addMessage =
                        'Tem certeza que deseja incluir o cupom de desconto para um produto específico?'),
                      (addDialog = true)
                  "
                  class="card-cupon pa-2 ma-2 py-7"
                >
                  <div>
                    <v-icon class="icon" style="font-size: xxx-large">
                      mdi-package-variant-closed
                    </v-icon>
                    <div>Produto</div>
                  </div>
                </v-card>
                <v-card
                  @click="
                    (type = 2),
                      (addTitle =
                        'Incluir cupom de desconto a clientes específicos'),
                      (addMessage =
                        'Tem certeza que deseja incluir o cupom de desconto para alguns clientes específicos?'),
                      (addDialog = true)
                  "
                  class="card-cupon pa-2 ma-2 py-7"
                >
                  <div>
                    <v-icon class="icon" style="font-size: xxx-large"
                      >mdi-account-circle-outline</v-icon
                    >
                    <div>Clientes específicos</div>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-tab-item>

        <v-tab-item :value="1" style="background: #eceef1 !important">
          <!-- Filtros1 -->
          <v-card
            transition="scale-transition"
            v-if="true"
            class="d-column mt-0 mb-0 py-0"
            elevation="2"
            color="#FFFFFF"
            style="border-radius: 6px"
          >
            <v-row>
              <p class="text-coupon-ativos-inativos">Guia de cupons ativos.</p>
            </v-row>

            <v-row style="justify-content: space-between; padding: 0 10px 30px">
              <v-col
                class="d-flex flex-column align-start my-1 py-1"
                cols="12" xs="12" sm="12" md="4" lg="4" xl="4"
              >
                <v-text-field
                  outlined
                  class="px-0"
                  style="
                    border: 1px solid #979797;
                    border-radius: 7.5px;
                    width: 100%;
                  "
                  color="black"
                  background-color="#F5F5F5"
                  hide-details
                  placeholder="Nome/Código"
                  v-model="filterCouponsActive.code"
                  attach
                  v-on:keyup="filterTableActive()"
                  :loading="loading"
                >
                  <template v-slot:append>
                    <v-icon class="pt-0" color="normalred" size="26"
                      >mdi-magnify</v-icon
                    >
                  </template>
                </v-text-field>
              </v-col>

              <v-col
                class="d-flex flex-column align-start my-1 py-1"
                cols="12" xs="12" sm="12" md="4" lg="4" xl="4"
              >
                <v-autocomplete
                  color="black"
                  clearable
                  v-model="filterCouponsActive.type"
                  :items="types"
                  item-text="text"
                  item-value="value"
                  attach
                  outlined
                  append-icon="mdi-chevron-down"
                  hide-details
                  style="width: 100%; border-radius: 7.5px"
                  required
                  placeholder="Tipos"
                  @change="filterTableActive()"
                  :loading="loading"
                ></v-autocomplete>
              </v-col>

              <v-col
                class="d-flex flex-column align-start my-1 py-1"
                cols="12" xs="12" sm="12" md="4" lg="4" xl="4"
              >
                <v-btn
                  block
                  outlined
                  height="56"
                  style="border-radius: 7.5px"
                  @click="reset"
                  >Limpar filtros
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
          <br />
          <!-- Tabela1 -->
          <v-data-table
            ref="coupon-table"
            :loading="loading"
            loading-text="Carregando..."
            no-data-text="Nenhum cupom ativo encontrado"
            :headers="headers1"
            :items="couponsActive"
            class="elevation-1 mytable content-table"
            style="cursor: pointer"
            hide-default-footer
            :items-per-page="pageSize"
            :header-props="headerProps"
            :key="componentKey"
          >
            <template v-slot:[`header.download`]="{ header }">
              <v-btn
                outlined
                tile
                icon
                v-on="header"
                class="quinary-button"
                style="border-radius: 5px"
                @click="exportExcel"
              >
                <v-icon>mdi-download-outline</v-icon>
              </v-btn>
            </template>

            <template v-slot:[`item.description`]="{ item }">
              <span>{{
                item.description.length > 0 ? item.description : "-"
              }}</span>
            </template>

            <template v-slot:[`item.validate_end`]="{ item }">
              <div>
                {{
                  item.validate_end != null
                    ? formatDate(item.validate_end)
                    : "Indeterminado"
                }}
              </div>
            </template>

            <template v-slot:[`item.used`]="{ item }">
              <div>
                {{ item.used != null ? item.used : 0 }}
              </div>
            </template>

            <template v-slot:[`item.type`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    {{
                      item.type == 0
                        ? "Produtos Selecionados"
                        : item.type == 1
                        ? "Toda loja"
                        : item.type == 2
                        ? "Clientes Selecionados"
                        : item.type == 3
                        ? "Categoria Selecionados"
                        : item.type == 4
                        ? "Subcategoria Selecionados"
                        : item.type == 5
                        ? "Produto selecionado"
                        : "Toda Loja"
                    }}
                  </div>
                </template>
                <span>{{
                  item.type == 1
                    ? "Produtos Selecionados"
                    : item.type == 2
                    ? "Clientes Selecionados"
                    : "Toda Loja"
                }}</span>
              </v-tooltip>
            </template>

            <template
              v-slot:[`item.actions`]="{ item }"
              cols="12"
              md="6"
              xs="12"
              sm="12"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    class="quinary-button ma-2"
                    @click="goToDetails(item)"
                  >
                    Detalhar
                  </v-btn>
                </template>
                <span>Detalhar</span>
              </v-tooltip>
            </template>

            <template v-slot:footer class="ma-0 pa-0">
              <section class="ma-0 pa-0">
                <Pagination
                    v-if="totalItemsCouponsActive > pageSize"
                    :currentPage="currentPageCouponsActive"
                    :totalItems="totalItemsCouponsActive"
                    :page="pageCouponsActive"
                    :pageSize="pageSize"
                    :totalPages="totalPagesCouponsActive"
                    @back-page="backPageCouponActive"
                    @next-page="nextPageCouponActive"
                >
                </Pagination>
              </section>
            </template>
          </v-data-table>
        </v-tab-item>

        <v-tab-item :value="2" style="background: #eceef1 !important">
          <!-- Filtros2 -->
          <v-card
            transition="scale-transition"
            v-if="true"
            class="d-column mt-0 mb-0 py-0"
            elevation="2"
            style="border-radius: 6px"
          >
            <v-row>
              <p class="text-coupon-ativos-inativos">
                Lista de cupons ativos/inativos.
              </p>
            </v-row>

            <v-row style="justify-content: space-between; padding: 0 10px 30px">
              <v-col
                class="d-flex flex-column align-start my-1 py-1"
                cols="12" xs="12" sm="12" md="4" lg="4" xl="4"
              >
                <v-text-field
                  outlined
                  class="px-0"
                  style="
                    border: 1px solid #979797;
                    border-radius: 7.5px;
                    width: 100%;
                  "
                  color="black"
                  background-color="#F5F5F5"
                  hide-details
                  placeholder="Nome/Código"
                  v-model="filter.code"
                  attach
                  v-on:keyup="filterTable()"
                  :loading="loading"
                >
                  <template v-slot:append>
                    <v-icon class="pt-0" color="normalred" size="26"
                      >mdi-magnify</v-icon
                    >
                  </template>
                </v-text-field>
              </v-col>

              <v-col
                class="d-flex flex-column align-start my-1 py-1"
                cols="12" xs="12" sm="12" md="4" lg="4" xl="4"
              >
                <v-autocomplete
                  color="black"
                  clearable
                  v-model="filter.status"
                  :items="status"
                  item-text="text"
                  item-value="text"
                  attach
                  outlined
                  append-icon="mdi-chevron-down"
                  hide-details
                  style="width: 100%; border-radius: 7.5px"
                  required
                  placeholder="status"
                  @change="filterTable()"
                  :loading="loading"
                ></v-autocomplete>
              </v-col>

              <v-col
                class="d-flex flex-column align-start my-1 py-1"
                cols="12" xs="12" sm="12" md="4" lg="4" xl="4"
              >
                <v-btn
                  block
                  outlined
                  height="56"
                  style="border-radius: 7.5px"
                  @click="reset"
                  >Limpar filtros
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
          <!-- Tabela2 -->
          <br />

          <v-data-table
            ref="coupon-table"
            :loading="loading"
            loading-text="Carregando..."
            no-data-text="Nenhum cupom encontrado"
            :headers="headers2"
            :items="coupons"
            class="elevation-3 mytable content-table"
            style="cursor: pointer"
            hide-default-footer
            :items-per-page="pageSize"
            :header-props="headerProps"
            :key="componentKey"
            v-model="selectedCoupons"
            show-select
            item-key="id"
            :single-select="false"
          >
            <template v-slot:[`header.download`]="{ header }">
              <v-btn
                outlined
                tile
                icon
                v-on="header"
                class="quinary-button"
                style="border-radius: 5px"
                @click="exportExcel"
              >
                <v-icon>mdi-download-outline</v-icon>
              </v-btn>
            </template>

            <template v-slot:[`item.descontoReais`]="{ item }">
              <div>
                {{
                  item.descontoReais != null
                    ? "R$ " + item.descontoReais
                    : item.descontoPercentual + " %"
                }}
              </div>
            </template>

            <template v-slot:[`item.description`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <div class="product-name-field long-name" v-on="on">
                    {{ item.description.length > 0 ? item.description : "-" }}
                  </div>
                </template>
                <span>{{
                  item.description.length > 0 ? item.description : "-"
                }}</span>
              </v-tooltip>
            </template>

            <template v-slot:[`item.used`]="{ item }">
              <div>
                {{ item.used != null ? item.used : 0 }}
              </div>
            </template>

            <template v-slot:[`item.status`]="{ item }">
              <div class="d-flex justify-center align-center pa-1 ma-0">
                <v-select
                  class="ma-3 pa-0"
                  style="max-width: 110px !important"
                  dense
                  hide-details
                  outlined
                  :loading="statusLoading"
                  :items="status"
                  @change="changeStatus(item)"
                  item-text="text"
                  item-value="value"
                  v-model="item.status"
                >
                  <template v-slot:selection="{ item }">
                    <span class="normal">{{ item.text }}</span>
                  </template>
                </v-select>
              </div>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    class="quinary-button ma-2"
                    @click="goToDetails(item)"
                  >
                    Detalhar
                  </v-btn>
                </template>
                <span>Detalhar</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    outlined
                    fab
                    tile
                    style="border-radius: 6px"
                    small
                    class="quinary-button ma-1 edit-button"
                    color="quaternary"
                    @click="editCoupon(item)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon dark>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Editar</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-if="showCheckbox(item)"
                    outlined
                    fab
                    tile
                    style="border-radius: 6px"
                    small
                    class="ma-1 quinary-button"
                    color="red"
                    @click="deleteCoupon(item)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon dark>mdi-trash-can-outline</v-icon>
                  </v-btn>
                </template>
                <span>Remover</span>
              </v-tooltip>
            </template>

            <template v-slot:header.data-table-select="{ on, props}">
              <v-simple-checkbox
                  color="#bc0000"
                  v-bind="props"
                  v-on="on"
                  :ripple="false"
              >
              </v-simple-checkbox>
            </template>

            <template v-slot:item.data-table-select="{ on, props, isSelected, item }">
              <v-simple-checkbox
                  :ripple="false"
                  @click="addCouponListSelectedCoupons(item)"
                  :value="isSelected"
                  color="#bc0000"
                  v-bind="props"
                  v-on="on"
              >
              </v-simple-checkbox>
            </template>

            <template v-slot:footer >
              <section class="ma-0 pa-0">
                <Pagination
                    v-if="totalItems > pageSize"
                    :currentPage="currentPage"
                    :totalItems="totalItems"
                    :page="page"
                    :pageSize="pageSize"
                    :totalPages="totalPages"
                    @back-page="backPage"
                    @next-page="nextPage"
                >
                </Pagination>
              </section>

              <v-row cols="12" class="mx-0 mb-0 mt-1 " v-if="selectedCoupons.length > 0">
                <v-col cols="12" class="ma-0 pa-0 pa-0 mb-0 mt-2">
                  <v-divider></v-divider>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4" class="ma-0 pa-0 pa-0 mb-0 mt-2">
                  <label>Selecione a ação</label>
                  <v-select
                      class="ma-0 pa-0 "
                      dense
                      v-model="action"
                      outlined
                      style="border-radius: 3px!important"
                      :items="actions"
                      item-text="label"
                      item-value="value"
                      placeholder="Selecione a ação"
                  >
                  </v-select>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="5" lg="5" xl="5" class="ma-0 pa-0 mt-2">
                  <v-btn
                      class="secondary-button mt-5 ml-3"
                      style="height: 40px!important; border-radius: 7.5px!important"
                      height="40"
                      width="100%"
                      elevation="0"
                      :disabled="!action"
                      @click="confirmActionDialog = true"
                  >
                    {{ action ? actions.find((x) => x.value === action).label : 'Selecione a ação'}}
                  </v-btn>
                </v-col>
              </v-row>
            </template>
          </v-data-table>
        </v-tab-item>
      </v-tabs-items>
    </v-container>
  </v-main>
</template>

<style scoped>
.text-coupon-ativos-inativos {
  padding: 20px 0 0 20px;
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 35px;
  color: #9c9c9c;
}
.normal {
  font-style: normal;
  font-weight: 300;
  font-size: 15px;
  line-height: 18px;
  letter-spacing: 0.15px;
  color: #979797;
}
.type-coupon-title {
  font-style: normal;
  font-weight: bold;
  font-size: 25px;
  line-height: 29px;
  text-align: center;
  letter-spacing: 0.15px;
  color: #232021;
}

.type-coupon-description {
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 25px;
  text-align: center;
  letter-spacing: 0.15px;
  color: #232021;
}
.product-name-field {
  white-space: nowrap !important;
  width: 255px !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;

  font-weight: 300;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 0.15px;
}
.long-name {
  width: 300px !important;
}

.text-card {
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 21px;
  letter-spacing: 0.15px;

  text-align: -webkit-center !important;

  color: #979797;
}

.title-g {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 28px;
  line-height: 40px;

  color: #000000;
}
.texto-p {
  font-family: Roboto;
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 35px;
  color: #9c9c9c;
}
.card-cupon {
  text-align: center;
  width: 180px;
  height: 150px;
  background: #f5f5f5;
  border: 1px solid #979797;
  box-sizing: border-box;
  border-radius: 10px;

  font-weight: 600;
  font-size: 13px;
  line-height: 21px;
  text-align: center;
  letter-spacing: 0.15px;

  color: #979797;
}
.card-cupon:hover {
  color: #ffffff !important;
  background: #bc0000;
  border: 1px solid #bc0000;
  box-sizing: border-box;
  border-radius: 10px;
}
.card-cupon:hover .icon {
  color: #ffffff !important;
}

.active-tab {
  background: #2d3038;
  color: #ffffff !important;
}
@media (max-width: 330px) {
  .v-menu__content {
    left: 15px !important;
    max-width: unset;
  }
}
</style>

<script>
import ApiService from "../../../../services/ApiService";
import HeaderProduct from "../components/HeaderProduct/HeaderProduct.vue";
import ExcelModal from "../../components/ExcelModal.vue";
import AprovalModal from "../../components/AprovalModal.vue";
import DeleteModal from "../../components/DeleteModal.vue";
import DetailsCoupon from "../../components/DetailsCoupon.vue";
import { VMoney } from "v-money";
import Vue from "vue";
import Utils from "../../../../Utils/FormatDate";
import moment from "moment";
import { type } from "os";
import ConfirmModal from "@/views/pages/components/ConfirmModal.vue";
import Pagination from "@/views/pages/components/Pagination.vue";

export default {
  components: {
    ConfirmModal,
    Pagination,
    HeaderProduct,
    ExcelModal,
    DeleteModal,
    DetailsCoupon,
  },

  data: () => ({
    selectedCoupons: [],
    actions: [
      { label: "Inativar cupom(s)", value: 1},
      { label: "Ativar cupom(s)", value: 2},
      { label: "Excluir cupom(s)", value: 3},
    ],
    action: null,
    confirmActionDialog: false,
    type: 0,
    addMessage: "",
    addTitle: "",
    types: [
      {
        text: "toda loja",
        value: 1,
      },
      {
        text: "produtos selecionados",
        value: 0,
      },
      {
        text: "clientes selecionados",
        value: 2,
      },
      {
        text: "categoria selecionada",
        value: 3,
      },
      {
        text: "subcategoria selecionados",
        value: 4,
      },
      {
        text: "produto selecionado",
        value: 5,
      },
    ],
    orders: [
      {
        text: "Crescente",
        value: 0,
      },
      {
        text: "Decrescente",
        value: 1,
      },
    ],
    deleteDialog: false,
    status: [
      { text: "Inativo", value: 0 },
      { text: "Ativo", value: 1 },
    ],
    currentCoupon: [],
    statusLoading: false,
    couponsActive: [],
    coupons: [],
    addDialog: false,
    ordersActive: [],
    componentKey: false,
    activeTab: 0,
    closeNoLoading: false,
    dialogKey: false,
    env_url: "",
    detailsDialog: false,
    excelDialog: false,
    loading: false,
    isLoading: false,
    page: 1,
    totalPages: 1,
    totalItems: 1,
    currentPage: 1,
    pageSize: 15,
    sizes: [15, 30, 90, 180],
    apiService: new ApiService(),
    filter: {
      Code: null,
      Benefits: null,
      Type: null,
      page: 1,
      pageSize: 15,
    },

    pageCouponsActive: 1,
    totalPagesCouponsActive: 1,
    totalItemsCouponsActive: 1,
    currentPageCouponsActive: 1,
    filterCouponsActive: {
      code: null,
      benefits: null,
      type: null,
      status: 'ativo',
      page: 1,
      pageSize: 15,
    },
    headers1: [
      {
        text: "Código",
        class: "item",
        value: "code",
        align: "start",
        sortable: false,
      },
      {
        text: "Descrição",
        class: "item",
        value: "description",
        align: "start",
        sortable: false,
      },
      {
        text: "Valido até",
        class: "item",
        value: "validate_end",
        align: "start",
        sortable: false,
      },
      {
        text: "Quant.",
        class: "item",
        value: "quantity",
        align: "start",
        sortable: false,
      },

      {
        text: "Usos",
        class: "item",
        value: "used",
        align: "start",
        sortable: false,
      },
      {
        text: "Tipo",
        class: "item",
        value: "type",
        align: "start",
        sortable: false,
      },

      {
        text: "Ações",
        class: "item",
        value: "actions",
        align: "center",
        sortable: false,
      },
      {
        align: "center",
        sortable: false,
        value: "download",
      },
    ],
    headers2: [
      {
        text: "Nome",
        class: "item",
        value: "code",
        align: "start",
        sortable: false,
      },
      {
        text: "Valor",
        class: "item",
        value: "descontoReais",
        align: "start",
        sortable: false,
      },
      {
        text: "Produtos em uso",
        class: "item",
        value: "used",
        align: "start",
        sortable: false,
      },
      {
        text: "Status",
        class: "item",
        value: "status",
        align: "center",
        sortable: false,
      },
      {
        text: "Ações",
        class: "item",
        value: "actions",
        align: "start",
        sortable: false,
      },
      {
        align: "center",
        sortable: false,
        value: "download",
      },
    ],
    headerProps: { sortByText: "Ordenar por" },
    money: {
      decimal: ",",
      thousands: ".",
      precision: 2,
      masked: false,
    },
  }),

  directives: { money: VMoney },

  async created() {
    await this.updateTable();
    await this.updateTableCouponActive();
    this.env_url = process.env.VUE_APP_BASE_URL;
  },

  mounted() {
    if (this.$route.query.actives != null) {
      this.elementClick();
    }
  },
  methods: {
    showCheckbox(coupon){
      return !(coupon.orders && coupon.orders.length > 0);
    },

    performAction(){
      this.confirmActionDialog = false;
      switch (this.actions.find((x) => x.value === this.action).label) {
        case 'Inativar cupom(s)':
          this.inactivateCoupons()
          break
        case 'Ativar cupom(s)':
          this.activateCoupons()
          break
        default:
          this.removeProducts()
      }
    },

    inactivateCoupons(){
      try {
        const selectedCoupons = JSON.parse(JSON.stringify(this.selectedCoupons))
        selectedCoupons.forEach((x) => {
          x.status = 0;
        })
        this.apiService
          .put("coupon/status/list", selectedCoupons)
          .then(() => {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "success",
              title: "",
              message: "Status dos cupons atualizado com sucesso.",
              trace: null,
            });
            this.updateTable();
          })
          .catch(() => {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "error",
              title: "Não foi possível atualizar o status dos cupons.",
              message: "",
              trace: null,
            });
          });
      } catch (e) {

      }
    },

    activateCoupons(){
      try {
        const selectedCoupons = JSON.parse(JSON.stringify(this.selectedCoupons))
        selectedCoupons.forEach((x) => {
          x.status = 1;
        })
        this.apiService
            .put("coupon/status/list", selectedCoupons)
            .then(() => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "success",
                title: "",
                message: "Status dos cupons atualizado com sucesso.",
                trace: null,
              });
              this.updateTable();
            })
            .catch(() => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "error",
                title: "Não foi possível atualizar o status dos cupons.",
                message: "",
                trace: null,
              });
            });
      } catch (e) {

      }
    },

    removeProducts(){
      try {
        const selectedCoupons = this.selectedCoupons.filter((coupon) => !coupon.orders || coupon.orders.length <= 0)
        this.apiService
            .post("coupon/delete/list", selectedCoupons)
            .then(() => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "success",
                title: "",
                message: "Cupons excluídos com sucesso.",
                trace: null,
              });
              this.updateTable();
            })
            .catch(() => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "error",
                title: "Não foi possível excluir os cupons.",
                message: "",
                trace: null,
              });
            });
      } catch (e) {

      }
    },

    addCouponListSelectedCoupons(coupon){
      if(!coupon.orders || coupon.orders.length <= 0) {
        const couponFind = this.selectedCoupons.findIndex((x) => x.id === coupon.id)
        if (couponFind > -1) {
          this.selectedCoupons.splice(couponFind, 1)
        } else {
          this.selectedCoupons.push(coupon)
        }
      }
    },

    async editCoupon(item) {
      this.currentCoupon = item;
      await this.$router.push({
        path: "/add-coupons?isEditing=true&id=" + item.id,
        params: item,
      });
    },

    reset() {
      this.filter = {
        page: 1,
        pageSize: 15,
      };
      this.page = 1;
      this.updateTable();
    },

    goToDetails(item) {
      this.currentCoupon = item;
      this.dialogKey = !this.dialogKey;
      this.detailsDialog = true;
    },

    changeStatus(item) {
      this.statusLoading = true;
      this.apiService
        .post("coupon/changestatus", item)
        .then(() => {
          this.statusLoading = false;
          this.updateTable();

          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "success",
            title: "Status alterado com sucesso",
            message: "Status alterado com sucesso",
            trace: null,
          });
        })
        .catch(() => {
          this.statusLoading = false;
          this.updateTable();

          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "",
            message: "Não foi possível remover o cupom selecionado.",
            trace: null,
          });
        });
    },

    deleteCoupon(item) {
      this.currentCoupon = item;
      this.dialogKey = !this.dialogKey;
      this.deleteDialog = true;
    },

    async remove() {
      this.loading = true;
      await this.apiService
        .delete(`coupon/delete`, this.currentCoupon)
        .then((resp) => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "success",
            title: "",
            message: "Cupom removido com sucesso",
            trace: null,
          });
          this.updateTable();
          this.loading = false;
        })
        .catch((err) => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "",
            message: "Não foi possível remover o cupom selecionado.",
            trace: null,
          });

          this.loading = false;
        });
    },

    elementClick() {
      var elemento = document.getElementById("tab2");
      elemento.click();
    },

    async goToRoute(route) {
      if (this.$route.path != route) {
        await this.$router.push(route);
      }
    },

    async updateTable() {
      this.loading = true;
      await this.apiService
        .post("coupon/list", this.filter)
        .then((response) => {
          //console.log(response)
          this.coupons = response.coupons;
          this.totalPages = response.pager.totalPages;
          this.totalItems = response.pager.totalItems;
          this.currentPage = response.pager.currentPage;
          this.componentKey = this.componentKey + 1;
          this.loading = false;
          this.action = null;
        })
        .catch((erro) => {
          this.loading = false;

          this.componentKey = this.componentKey + 1;
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "",
            message: "Não foi possível encontrar os cupons",
            trace: null,
          });
        });
    },

    async backPage() {
      this.filter.page -= 1;
      this.page = this.filter.page;
      await this.updateTable();
    },

    async nextPage() {
      this.filter.page += 1;
      this.page = this.filter.page;
      await this.updateTable();
    },

    async updateTableCouponActive() {
      this.loading = true;
      await this.apiService
        .post("coupon/list", this.filterCouponsActive)
        .then((response) => {
          this.couponsActive = response.coupons;
          this.totalPagesCouponsActive = response.pager.totalPages;
          this.totalItemsCouponsActive = response.pager.totalItems;
          this.currentPageCouponsActive = response.pager.currentPage;
          this.loading = false;
        })
        .catch((erro) => {
          this.loading = false;
          this.componentKey = this.componentKey + 1;
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "Não foi possível encontrar os cupons",
            message: "",
            trace: null,
          });
        });
    },

    async backPageCouponActive() {
      this.filterCouponsActive.page -= 1;
      this.pageCouponsActive = this.filterCouponsActive.page;
      await this.updateTableCouponActive();
    },

    async nextPageCouponActive() {
      this.filterCouponsActive.page += 1;
      this.pageCouponsActive = this.filterCouponsActive.page;
      await this.updateTableCouponActive();
    },

    async generateExcel() {
      this.loading = true;

      let now = new Date();
      var filename =
        `Cupons_` +
        `${now.getDate()}-${now.getMonth() + 1}-${now.getFullYear()}.xlsx`;

      await this.apiService
        .post("coupon/excel", this.filter)
        .then((response) => {
          response = "data:application/octet-stream;base64," + response;
          const link = document.createElement("a");
          link.href = response;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          this.loading = false;
        })
        .catch((erro) => {
          this.loading = false;
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "Não foi possível efetuar a exportação",
            message: "",
            trace: null,
          });
        });
    },

    formatDate(date) {
      return Utils.moment(date);
    },

    exportExcel(cupons) {
      this.currentCoupon = cupons;
      this.dialogKey = !this.dialogKey;
      this.excelDialog = true;
    },

    async filterTable() {
      this.loading = true;
      this.filter.page = 1;
      await this.updateTable()
      this.loading = false;
    },

    async filterTableActive() {
      this.loading = true;
      this.filterCouponsActive.page = this.page;
      await this.updateTableCouponActive()
      this.loading = false;
    },
  },

  watch: {},
};
</script>
